import Swal from "sweetalert2";
import tippy from 'tippy.js';
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { ProgressBar } from "../Global/Progressbar";

@ModuleName("OneRisk")
export class OneRisk implements AxInit {
    constructor(
        protected _Progressbar = new ProgressBar(),
        private _I18nHelper = new I18nHelper(),
        private _AxLoading = new AxLoading(),
    ) { }

    private init: OneRiskInit;
    private tippyInstanceInfo: any = [];
    private spinner: HTMLElement = $('<div>').get(0);
    private submitButtonOnclick: string = $('.input-consent-doc-submit-button').attr('onclick');

    AxInit(init: OneRiskInit): void {
        this.init = init;
        const haveOneRiskWaiver = $('[data-one-risk-completed]').length > 0;
        if (this.init.waiverIsEnabled && haveOneRiskWaiver && (this.init.oneRISKProcessRequired || this.init.waiverCompeling)) {
            $('.input-consent-doc-submit-button').attr('onclick', 'false');
        }
        this.checkIfWaiverIsEnabled();

        $('[data-waiver-email-sent]').on('click', (e) => {
            e.preventDefault();
            const $forwardEmail: JQuery<HTMLElement> = $(e.currentTarget);
            $forwardEmail.addClass('d-none');
            $forwardEmail.next().removeClass('d-none').find('input').trigger('focus').get(0).setSelectionRange(-1, -1);
        });

        $('[data-send-waiver]').on('click', (e) => {
            const $email: JQuery<HTMLElement> = $(e.target).siblings('input');
            const waiverEmail: string = $email.val().toString().trim() || '';
            const regex = RegExp(/^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/, 'i');
            $email.attr('placeholder', '');
            if (waiverEmail.length && regex.test(waiverEmail)) {
                const cartEntryID: number = $(e.target).data('send-waiver');
                const waiverURL: string = $(e.target).closest('.cartentry-tickets-waiver-buttons ').find('[data-one-risk-completed]').attr('href');
                this._AxLoading.ShowLoadingIndicator(this.spinner);
                $email.parent().append(this.spinner);
                const transNr: number = this.init.transactionNumber;
                AxessViewer.loadPartialView("/AxessWaiver/SendWaiverEmail", {
                    cartEntryID,
                    waiverURL,
                    waiverEmail,
                    transNr,
                }, ({ isWaiverSent }) => {
                    if (isWaiverSent) {
                        this._AxLoading.HideLoadingIndicator(this.spinner);
                        $email
                            .parent()
                            .addClass('d-none')
                            .prev('a')
                            .removeClass('d-none ax-btn-secondary--danger')
                            .addClass('ax-btn-secondary--success')
                            .attr('data-waiver-email-sent', 'true')
                            .data('waiver-email-sent', 'true');
                        this.handleWaiverRequired();
                    }
                });
            } else {
                $email.attr('placeholder', this._I18nHelper.GetTranslation(Translations.ValidationMail)).val('');
            }
        });

        $('[name=waiverEmail]').on('keyup', (e) => {
            if (e.key === 'Escape') {
                const $button: JQuery<HTMLElement> = $(e.target).parent().prev('a');
                $(e.target)
                    .parent()
                    .addClass('d-none');
                $button
                    .removeClass(`d-none ${$button.data('data-waiver-email-sent') === 'sent' ? 'ax-btn-secondary--danger' : ''}`)
                    .addClass($button.data('data-waiver-email-sent') === 'sent' ? 'ax-btn-secondary--success' : '');
            }
            if (e.key === 'Enter') {
                $('[data-send-waiver]').trigger('click');
            }
        }).on('blur', (e: any) => {
            const sendWaiver$: JQuery<HTMLElement> = $(e.relatedTarget);
            if (typeof sendWaiver$.attr('data-send-waiver') !== 'undefined') {
                $(e.relatedTarget).trigger('click');
            } else {
                const $this: JQuery<HTMLElement> = $(e.target);
                $this.parent().addClass('d-none');
                $this.parent().prev().removeClass('d-none');
            }
        });

        $('.btn_payment__overview').on('click', () => {
            this.checkIfWaiverIsEnabled();
        });

        $('[data-one-risk-entryid]').each((_, e) => {
            const tripple: string = $(e).data('waiver-for-entry');
            const serienNr: string = $(e).data('serial-for-entry');
            const cartEntryId: string = $(e).data('one-risk-entryid');
            const verifyWaiverStatus = setInterval(() => {
                const queryString = `personTriple=${tripple}&SerieNr=${serienNr}`;
                AxessViewer.loadPartialView('/OneRisk/CheckIfOneRiskProcessCompleted', queryString, ({ signingOffIsDone }: { signingOffIsDone: boolean }) => {
                    if (signingOffIsDone) {
                        const $message = $('<span>', {
                            class: 'waiver__tripple d-flex ax-btn ax-btn-primary ax-btn-primary--success ax-btn-icon ax-btn-icon--after ax-btn-sm',
                            'data-waiver-for-entry': tripple,
                            'data-serial-for-entry': serienNr,
                            'data-one-risk-completed': true,
                        }).append(
                            this._I18nHelper.GetTranslation(Translations.WaiverIsCompleted),
                            $('<i>', { class: 'la la-check-circle' }),
                        );
                        $(`#waiver__area_${cartEntryId}`).html($message.prop('outerHTML')).next().remove();
                        clearInterval(verifyWaiverStatus);
                        this.enablePaymentOverviewButton();
                    }
                });
            }, 2000);
        });
    }

    checkIfWaiverIsEnabled() {
        if (this.init.waiverIsEnabled) {
            this.handleWaiverRequired();
        } else {
            this.enablePaymentOverviewButton();
        }
    }

    handleWaiverRequired() {
        if (this.init.oneRISKProcessRequired || this.init.waiverCompeling) {
            this.checkAllOneRiskProcessesCompleted();
        } else {
            this.enablePaymentOverviewButton();
            this.handleOneRiskNotRequired();
        }
    }

    handleOneRiskNotRequired() {
        $('.input-consent-doc-submit-button').one('click', (e) => {
            e.preventDefault();
            Swal.fire({
                title: this._I18nHelper.GetTranslation(Translations.Warning),
                html: this._I18nHelper.GetTranslation(Translations.WaiverModal),
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    cancelButton: 'btn btn-secondary',
                    confirmButton: 'btn btn-primary',
                },
                confirmButtonText: this._I18nHelper.GetTranslation(Translations.Ok),
                cancelButtonText: this._I18nHelper.GetTranslation(Translations.Cancel),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.enablePaymentOverviewButton();
                }
            });
        });
    }

    checkAllOneRiskProcessesCompleted() {
        const $oneRiskCompleted = this.init.waiverCompeling ? $('[data-waiver-email-sent]') : $('[data-one-risk-completed]');
        const allWaiverCompleted = $oneRiskCompleted.toArray().every((e) => $(e).data('one-risk-completed'));
        const allWaiverForwarded = $oneRiskCompleted.toArray().every((e) => $(e).data('waiver-email-sent'));
        const allTrue = allWaiverCompleted || allWaiverForwarded;

        if (allTrue) {
            this.enablePaymentOverviewButton();
        } else {
            this.disablePaymentOverviewButtonWithTooltip();
        }
    }

    disablePaymentOverviewButtonWithTooltip() {
        const self = this;
        const isOneRiskReq = this.init.oneRISKProcessRequired;
        const isCompeling = this.init.waiverCompeling;
        const $consentDocButton = $('[data-consent-doc-submit-button]');

        if ((isOneRiskReq || isCompeling) && $consentDocButton.length > 0 && this.tippyInstanceInfo.length === 0) {
            const tooltipText = isCompeling
                ? this._I18nHelper.GetTranslation(Translations.OneRISKProcessIsRequiredBeforeProceed)
                : this._I18nHelper.GetTranslation(Translations.OneRISKProcessIsRequiredBeforeProceed);
            const selector = isCompeling
                ? document.querySelectorAll('[data-waiver-email-sent]')
                : document.querySelectorAll('.waiver__inactive');
            this.tippyInstanceInfo = tippy(selector, {
                content: tooltipText,
                placement: 'right',
                theme: 'light-border',
                interactive: true,
                trigger: 'manual',
            });
        }
        if ((isOneRiskReq || isCompeling) && $consentDocButton.length > 0) {
            $consentDocButton.prop('disabled', true);
            $consentDocButton
                .on('mouseenter', () => {
                    this.checkAllOneRiskProcessesCompleted();
                    this.tippyInstanceInfo.forEach((e, i) => {
                        const serialForEntry = $(e.reference).data('serial-for-entry');
                        if (
                            $(`a[data-serial-for-entry=${serialForEntry}]`).data('one-risk-completed') === false
                            || $(`a[data-serial-for-entry=${serialForEntry}]`).data('waiver-email-sent') === false
                        ) {
                            e.show();
                        } else {
                            e.destroy();
                            self.tippyInstanceInfo.splice(i, 1);
                        }
                    });
                })
                .on('mouseleave', () => {
                    this.tippyInstanceInfo.forEach((e) => {
                        e.hide();
                    });
                });
        }
    }

    enablePaymentOverviewButton() {
        if (this.tippyInstanceInfo.length > 0) {
            this.tippyInstanceInfo = [];
        }
        $('[data-consent-doc-submit-button]').prop('disabled', false).off();
        $('.input-consent-doc-submit-button').attr('onclick', this.submitButtonOnclick);
    }
}
class OneRiskInit {
    oneRISKProcessRequired?: boolean;
    waiverIsEnabled?: boolean;
    waiverCompeling: boolean;
    transactionNumber?: number;
}